import { Example } from '@/types/Example';
import { motion } from 'motion/react';
import { Check, CircleX } from 'lucide-react';
import React from 'react';
import CommandParagraph from './CommandParagraph';
import { AnswerLogEntry } from './QuizzQuestion';
import ShortDescription from './ShortDescription';
import { Card, CardContent, CardFooter } from './ui/card';

interface QuizzAnswerRevealProps {
  answer: AnswerLogEntry;
  example: Example;
}

const ICON_SIZE = 24;
const QuizzAnswerReveal = (props: QuizzAnswerRevealProps) => {
  const { answer, example } = props;

  const assessment = answer.correct ? (
    <Check size={ICON_SIZE} className="text-green-500" strokeWidth={2.2} />
  ) : (
    <div className="flex w-full items-end justify-between gap-4">
      <CircleX size={ICON_SIZE} className="text-red-500" />
      <div className="space-x-2 text-xs text-gray-500 sm:text-sm">
        <span>Your answer:</span>
        <span className="text-red-500">{answer.user_answer}</span>
      </div>
    </div>
  );

  return (
    <motion.div
      className="w-full"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card className="pt-6">
        <CardContent>
          <CommandParagraph command={example.example} as="h2" />
          <ShortDescription description={example.short_description} />
        </CardContent>
        <CardFooter>{assessment}</CardFooter>
      </Card>
    </motion.div>
  );
};

export default QuizzAnswerReveal;
